import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import { computed } from 'vue'
import { useRouter } from 'vue-router'
import AlertModal from '@/components/designSystem/Alerts/index.vue'
import AppUpdateNotice from '@/components/AppUpdateNotice.vue'
import { useAppVersionPolling } from '@/hooks/useAppVersionCheck'
import { resolveLayout } from '@/utils/layout'
import { isCompanyAuthenticated } from '@/utils/storage'


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

useAppVersionPolling()

const { currentRoute } = useRouter()

const layout = computed(() => resolveLayout(currentRoute.value, isCompanyAuthenticated()))

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_openBlock(), _createBlock(_resolveDynamicComponent(layout.value), { translate: "no" }, {
      default: _withCtx(() => [
        _createVNode(_component_router_view),
        _createVNode(AlertModal)
      ]),
      _: 1
    })),
    _createVNode(AppUpdateNotice)
  ], 64))
}
}

})